import React from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import "../../../assets/css/master.css"
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { generatePDF } from '../../commonClass/CommonValidation'
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { GetMenuIdFromStorage } from '../../commonClass/Menudect';
import CustomTable from '../../../customControl/CustomTable';


const Exclusionmaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // var store = useContext(ReactReduxContext).store.getState();
    const [modalShow, setModalShow] = useState(false);
    const [activeId, setActiveId] = useState();
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(true);
    const [exclusionerrorMessage, setExclusionErrorMessage] = useState('');
    const [exclusionduplicateerrorMessage, setExclusionDuplicateErrorMessage] = useState('');
    const [formValue, setFormValue] = useState(
        {
            ExclusionId: 0,
            ExclusionName: '',
            IsActive: false,
        }
    );
    const [exclusionlistdata, setExclusionListData] = useState([]);

    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('3');
    const [serchdisable, setSerachDisable] = useState(false);
    const [filteritems, setFilterItems] = useState([]);
    const [clrshow, setsclshow] = useState(false);
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const serachoption = [
        {
            label: 'Exclusion Name',
            value: '1'
        },
        {
            label: 'Active',
            value: '2'
        },
        // {
        //     label: 'Created Date',
        //     value: '4'
        // },
        {
            label: 'All',
            value: '3'
        },

    ];


    ///////////////////get list data///////////////////////////////////////////////////
    //#region List data
    const getExclusionDataList = async () => {
        const ExclusionListdata = await getAllData("/master/v1/getallexclusion");
        setExclusionListData(ExclusionListdata.data);
    }
    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            //if (Window.$name && Window.$userToken) {
            getExclusionDataList().then(() => { dispatch(loaderActions.end()) });;
            setitems();
        }
        else {
            ClearLocalStorage();
            // alert('Your Session Expired. Please Login Again!');
            // navigate('/');
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }, []);

    useEffect(() => {
        // let MENUID = GetMenuIdFromStorage()
        // let viewrights = false;
        // user?.filter(x => x.MenuId === MENUID).map((obj) => {
        //     viewrights = obj.URightView;
        //     setUserAdd(obj.URightAdd);
        //     setUserEdit(obj.URightEdit);
        //     setUserExport(obj.URightExport);
        //     if (!viewrights) {
        //         navigate('/dashboard');
        //     }
        // });
        // let MENUID = GetMenuIdFromStorage();
        // let mid = user?.find(x => x.MenuId === MENUID);
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }, [user])
    const columns = [

        {
            name: 'Exclusion Name',
            sortable: true,
            float: "left",
            selector: (exclusion) => exclusion.exclusionName,
            // style:  { backgroundColor: 'green' }
        },


        {
            name: 'Active',
            sortable: true,
            float: "left",
            selector: (exclusion) => exclusion.isActive ? 'Active' : 'InActive'
        },
        {
            name: 'Created Date',
            sortable: true,
            float: "left",
            selector: (exclusion) => new Date(exclusion.createdDate),
            format: (exclusion) => formatDate(exclusion.createdDate),
            // style:  { backgroundColor: 'green' }
        },
        {
            name: 'Edit',
            // float:"right",
            //selector: location => <td style={{ textAlign: "center", width: "5%", cursor:"pointer" }} onClick={() => handleEditMode(location.destinationId)}> <i className="fa fa-edit"></i></td >
            selector: (exclusion) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditMode(exclusion.exclusionId)}></i></button>
        },
        {
            name: 'View',
            // float:"right",
            //selector: location => <td style={{ textAlign: "center", width: "5%", cursor:"pointer" }} onClick={() => handleViewMode(location.destinationId)}><i className="fa fa-eye"></i></td>
            selector: (exclusion) => <i className="fa fa-eye" onClick={() => handleViewMode(exclusion.exclusionId)}></i>
        }
    ];




    //////////////////////////////use effect section //////////////////////////////////
    //#region  use effect section

    useEffect(() => {

    }, [exclusionerrorMessage]);


    useEffect(() => {

    }, [buttonaddeditText]);
    //#endregion
    //////////////////////////////////////////////////////////////////////////////////////////////


    const handleAddClick = async () => {
        let statusoftoken = await verifytoken();
        if (buttonaddeditText === 'Add') {
            if (statusoftoken) {
                if (!validateData()) {
                    return;
                }
                else {
                    let filterdata;
                    filterdata = exclusionlistdata?.filter(issec => issec.exclusionName.toLowerCase() === formValue.ExclusionName.toLowerCase());
                    if (filterdata?.length > 0) {
                        setExclusionDuplicateErrorMessage('You can not enter duplicate value.');
                        return;
                    }
                    if (statusoftoken) {
                        const ExclusionData = await postUsersData("/master/v1/insertexclusion", formValue);

                        if (!ExclusionData.status && !ExclusionData.data) {
                            setExclusionDuplicateErrorMessage(ExclusionData.message);
                            return;
                        }
                        if (ExclusionData.status) {
                            if (ExclusionData.data > 0) {
                                dispatch({ type: 'ALERTING', message: ExclusionData.message })
                                // alert('Exclusion master Record saved successfully');

                                clear();
                            }
                            else {
                                dispatch({ type: 'ALERTING', message: ExclusionData.message })
                                // alert('Exclusion master Record not saved successfully')
                                return;
                            }
                        }
                        else {
                            dispatch({ type: 'ALERTING', message: ExclusionData.message })
                            // alert('Something went wrong!')
                            return;
                        }
                    }
                    else {
                        ClearLocalStorage();
                        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                    }
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        else {
            if (statusoftoken) {
                if (!validateData()) {
                    return;
                }
                else {
                    let filterdata;
                    filterdata = exclusionlistdata?.filter(issec => issec.exclusionId !== formValue.ExclusionId && issec.exclusionName.toLowerCase() === formValue.ExclusionName.toLowerCase());
                    if (filterdata?.length > 0) {
                        setExclusionDuplicateErrorMessage('You can not enter duplicate value.');
                        return;
                    }
                    if (statusoftoken) {
                        const ExclusionData = await patchUsersData("/master/v1/updateexclusion", formValue);

                        if (!ExclusionData.status && !ExclusionData.data) {
                            setExclusionDuplicateErrorMessage(ExclusionData.message);
                            return;
                        }
                        if (ExclusionData.status) {
                            dispatch({ type: 'ALERTING', message: ExclusionData.message })
                            // alert('Exclusion master Record updated successfully');
                            clear();
                        }
                        else {
                            dispatch({ type: 'ALERTING', message: ExclusionData.message })
                            // alert('Something went wrong!')
                            return;
                        }
                    }
                    else {
                        ClearLocalStorage();
                        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                    }
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }
    const validateData = () => {
        if (typeof formValue.ExclusionName === 'string' && formValue.ExclusionName?.trim()?.length === 0) {
            setExclusionErrorMessage('Please enter Exclusion Name');
            document.getElementById("txtExclusion").focus();
            return false;
        }
        if (typeof formValue.ExclusionName === 'string' && formValue.ExclusionName?.trim()?.length > 500) {
            setExclusionErrorMessage('Maximum length allowed for Exclusion is 500 characters.');
            document.getElementById("txtExclusion").focus();
            return false;
        }
        return true;
    }
    const handleEditMode = (id) => {
        setDisabled(false);
        setEditDisabled(false);
        setSerachDisable(true);
        setButtonAddEditText("Update");
        RetriveData(id);
    }
    const handleViewMode = (id) => {
        setDisabled(true);
        setEditDisabled(false);
        setSerachDisable(true);
        RetriveData(id);
    }

    function RetriveData(id) {
        setExclusionErrorMessage('');
        setExclusionDuplicateErrorMessage('');

        exclusionlistdata?.map(obj => {
            if (obj.exclusionId === id) {
                // let active = !obj.isActive;
                formValue.ExclusionId = obj.exclusionId
                formValue.ExclusionName = obj.exclusionName
                formValue.IsActive = obj.isActive
                setActiveId(obj.isActive);
            }
        });
        setFormValue({ ...formValue, formValue })
    }
    const onChange = (e) => {
        setEditDisabled(true);
        setExclusionErrorMessage('');
        setExclusionDuplicateErrorMessage('');
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
    };
    //region image upload
    // const handleisActive = (e) => {
    //     { formValue.IsActive = e }
    //     setActiveId(!activeId)
    //     setEditDisabled(true);
    // }
    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            formValue.IsActive = e
            setActiveId(!activeId)
            setExclusionErrorMessage('');
            setExclusionDuplicateErrorMessage('');
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        //setYesNoConfirm(e)
        if (e === true) {
            formValue.IsActive = !activeId
            setActiveId(!activeId)
            setEditDisabled(true);
            setExclusionErrorMessage('');
            setExclusionDuplicateErrorMessage('');
        }
        setModalShow(false);
    }
    //endregion
    const handleClearClick = () => {
        // window.location.reload(true);
        clear();

    }
    function clear() {

        setFormValue({ ...formValue, ExclusionId: 0, ExclusionName: '', IsActive: false });
        setActiveId(false);
        getExclusionDataList();
        setButtonAddEditText('Add');
        setDisabled(false);
        setEditDisabled(true);
        setExclusionErrorMessage('');
        setExclusionDuplicateErrorMessage('');
        setSerachDisable(false);
        setSerachBy('3');
        setSearchValue('');
        setsclshow(false)
    }
    //#endregion

    //#region handle pdf and excel import
    function PdfExport() {
        //print
        const columns = [
            "Exclusion Name",
            "Active",
            "Created Date"
        ];
        var rows = [];

        for (let i = 0; i < exclusionlistdata?.length; i++) {
            var temp = [
                exclusionlistdata[i].exclusionName,
                `${exclusionlistdata[i].isActive ? 'Active' : 'InActive'}`,
                formatDate(exclusionlistdata[i].createdDate)
            ];
            rows = [...rows, temp]
        }
        generatePDF(columns, rows, "ExclusionMaster", "Exclusion Master")
    }

    const ExportToExcel = () => {
        const displayname = ['Exclusion Name', 'Active', 'Created Date'];
        const fields = ['exclusionName', 'isActive', 'createdDate'];
        ExportExcel(displayname, fields, exclusionlistdata, 'ExclusionMaster', 'ExclusionMaster.xls')
    }
    //#endregion

    //#region handle search value
    const setitems = async () => {
        const ExclusionListData = await getAllData("/master/v1/getallexclusion");
        setFilterItems(ExclusionListData.data);
    }

    const handleSearchBy = (e) => {
        setSerachBy(e.value);
    }
    const handleChangeSearchValue = (e) => {
        setSearchValue(e.target.value)
        setsclshow(true)
        if (e.target.value === '') {
            getExclusionDataList();
            setsclshow(false)
        }
    }

    const onKeyDownHandler = (e) => {
        if (e.keyCode === 13) {
            handleSearch();
        }
    };

    const handleSearch = () => {
        if (typeof searchvalue === 'string' && searchvalue?.trim()?.length !== 0 && searchby > 0) {
            setitems();
            var filteritem = filteritems;
            var filterdata;
            if (searchby === '1') {
                filterdata = filteritem?.filter(issec => issec.exclusionName.toLowerCase().includes(searchvalue.toLowerCase()));
            }
            else if (searchby === '4') {
                filterdata = filteritem?.filter(issec => formatDate(issec.createdDate).toLowerCase().includes(searchvalue.toLowerCase()));
            }
            else if (searchby === '2') {
                if (searchvalue.toLocaleLowerCase() === 'active'.toLocaleLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.isActive === true);
                }
                else if (searchvalue.toLowerCase() === 'inactive'.toLocaleLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.isActive === false);
                }
                else if ('active'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.isActive === true || issec.isActive === false);
                }
                else if ('inactive'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.isActive === false);
                }
                else {
                    filterdata = filteritem?.filter(issec => formatDate(issec.createdDate).toLowerCase().includes("%#$&%^"));
                }
            }
            else if (searchby === '3') {
                if (searchvalue.toLocaleLowerCase() === 'active'.toLocaleLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.exclusionName.toLowerCase().includes(searchvalue.toLowerCase()) || formatDate(issec.createdDate).toLowerCase().includes(searchvalue.toLowerCase()) || issec.isActive === true);
                }
                else if (searchvalue.toLowerCase() === 'inactive'.toLocaleLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.exclusionName.toLowerCase().includes(searchvalue.toLowerCase()) || formatDate(issec.createdDate).toLowerCase().includes(searchvalue.toLowerCase()) || issec.isActive === false);
                }
                else if ('active'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.exclusionName.toLowerCase().includes(searchvalue.toLowerCase()) || formatDate(issec.createdDate).toLowerCase().includes(searchvalue.toLowerCase()) || issec.isActive === true || issec.isActive === false);
                }
                else if ('inactive'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.exclusionName.toLowerCase().includes(searchvalue.toLowerCase()) || formatDate(issec.createdDate).toLowerCase().includes(searchvalue.toLowerCase()) || issec.isActive === false);
                }
                else {
                    filterdata = filteritem?.filter(issec => issec.exclusionName.toLowerCase().includes(searchvalue.toLowerCase()) || formatDate(issec.createdDate).toLowerCase().includes(searchvalue.toLowerCase()) || 'active'.toLowerCase().includes(searchvalue) || 'inactive'.toLowerCase().includes(searchvalue));
                }
            }
            setExclusionListData(filterdata)
        }
    }

    const clearsearch = () => {
        setSearchValue("");
        setsclshow(false);
        getExclusionDataList();
    }
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }
    return (
        <>
            <div class="container-fluid mt-4 heading_color">
                <h3>Exclusion Master</h3>
            </div>
            <div class="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div class="mb-3 row mx-1">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="row">
                                <div className='col-md-12'>
                                    <div className='row'>
                                        {exclusionduplicateerrorMessage && <div className="text-danger pb-3 text-center"> {exclusionduplicateerrorMessage} </div>}
                                        <div class="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label for="inputPassword6" class="col-form-label required">Exclusion Name</label>
                                        </div>
                                        <div class=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <textarea type="text" rows={2} id="txtExclusion" class="form-control"
                                                name="ExclusionName"
                                                value={formValue.ExclusionName}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder="Exclusion"
                                            >
                                            </textarea>
                                            {exclusionerrorMessage && <div className="text-danger"> {exclusionerrorMessage} </div>}
                                        </div>
                                        <div class="col-lg-3 col-md-12 col-sm-12">
                                            <label for="inputPassword6" class="col-form-label">Active</label>
                                        </div>
                                        <div class="col-auto col-lg-6" disabled={false}>

                                            <Switch
                                                onChange={handleisActive}
                                                checked={activeId}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        {/* <div class=" col-auto col-lg-4"> */}
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />

                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" class="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick} >Clear</button>
                    </div>
                    <div class="row">
                        <div className='d-lg-flex d-md-flex d-sm-block justify-content-end'>
                            <div class="p-2 col-lg-2 col-md-4 col-sm-12">
                                <Select
                                    className="dropdown select_dropdown"
                                    options={serachoption}
                                    value={serachoption?.filter(function (serachoption) {
                                        return serachoption.value === searchby;
                                    })}// set list of the dataalue 
                                    onChange={handleSearchBy} // assign onChange function
                                    isDisabled={serchdisable ? true : false}
                                    isSearchable={false}

                                />
                            </div>
                            <div class="p-2 col-lg-2 col-md-4 col-sm-12">
                                <div className='clrbutton'>
                                    <input type="text" onKeyDown={onKeyDownHandler} id="btnSearchText" class="form-control" placeholder='Enter keyword' name="SearchValue" onChange={handleChangeSearchValue} value={searchvalue || ''} disabled={serchdisable ? true : false} />
                                    <button className={`${clrshow === true ? "d-block" : "d-none"}`} disabled={serchdisable ? true : false} onClick={clearsearch} type="reset">&times;</button>
                                </div>
                            </div>
                            <div class="p-2 text-center">
                                <button type="button" class="btn btn-primary mx-1" id="btnSearch" disabled={serchdisable ? true : false} onClick={handleSearch}>Search</button>
                            </div>
                        </div>

                    </div>

                    <CustomTable
                        columns={columns}
                        data={exclusionlistdata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default Exclusionmaster